import { atom } from 'nanostores';
import { trackCanvasClosed, trackCanvasOpened } from '~/lib/element-selector/analytics';

/**
 * Canvas Mode state - a fullscreen Figma-like editing experience.
 * Separate from the existing element-selector stores to keep concerns isolated.
 */

export const $canvasMode = atom<boolean>(false);

/** Enter fullscreen canvas editing mode */
export function enterCanvasMode() {
  if (!$canvasMode.get()) {
    trackCanvasOpened();
  }

  $canvasMode.set(true);
}

/** Exit canvas mode and return to normal preview */
export function exitCanvasMode() {
  if ($canvasMode.get()) {
    trackCanvasClosed();
  }

  $canvasMode.set(false);
}

/** Toggle canvas mode */
export function toggleCanvasMode() {
  if ($canvasMode.get()) {
    exitCanvasMode();
  } else {
    enterCanvasMode();
  }
}
